/**
 * Utility to clear Redux Persist data from localStorage
 * Use this when you need to reset persisted state
 */
export function clearPersistedData() {
  try {
    // Clear the persisted Redux state
    localStorage.removeItem("persist:mercury-admin-redux");
    console.log("✅ Cleared persisted Redux data from localStorage");
    return true;
  } catch (error) {
    console.error("❌ Error clearing persisted data:", error);
    return false;
  }
}

/**
 * Clear all localStorage data (use with caution)
 */
export function clearAllLocalStorage() {
  try {
    localStorage.clear();
    console.log("✅ Cleared all localStorage data");
    return true;
  } catch (error) {
    console.error("❌ Error clearing localStorage:", error);
    return false;
  }
}

// Make it available globally for console debugging
if (typeof window !== "undefined") {
  window.clearPersistedData = clearPersistedData;
  window.clearAllLocalStorage = clearAllLocalStorage;
}
